import { createPublicClient, http } from "viem";
import { getChainFromConfig } from "../utils/chain-utils";
const clients = /* @__PURE__ */ new Map();
const getClient = async (chainId) => {
  if (!chainId) {
    throw new Error("Chain ID is required");
  }
  if (!clients.has(chainId)) {
    const chain = await getChainFromConfig(chainId);
    const client = createPublicClient({
      chain,
      transport: http(chain.rpcUrls.default.http[0])
    });
    clients.set(chainId, client);
  }
  return clients.get(chainId);
};
export {
  getClient
};
//# sourceMappingURL=client.mjs.map